import React, { useContext, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import NavbarTop from './navbar/NavbarTop';
import NavbarBottom from './navbar/NavbarBottom';
import authContext from '../context/authentication/authContext';
import Routes from '../utils/Routes';

function SharedLayout() {
    const aContext = useContext(authContext);
    const { autenticado, cargando } = aContext;
    const navigate = useNavigate();

    useEffect(() => {
        if (!cargando && !autenticado) {
            navigate(Routes.login);
        }
    }, [autenticado, cargando]);

    if (cargando) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                Cargando...
            </Box>
        );
    }

    if (!autenticado) {
        return null;
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <NavbarTop />
            <Box sx={{ flex: 1, p: 2, pb: 8, backgroundColor: '#f5f5f5' }}>
                <Outlet />
            </Box>
            <NavbarBottom />
        </Box>
    );
}

export default SharedLayout;
